import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { defineCustomElements } from 'groot-ui/loader';
import 'groot-ui/dist/groot-ui/groot-ui.css';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
let jsPath = '/assets/scripts/prod.js';
let jsShieldPath = 'https://d1cr9zxt7u0sgu.cloudfront.net/shdfp.js?SITE_ID=f090f742649c84aa50bc40cdb559b55eb85def43&TYPE=JS&DE=1&AUTO=0';
const partnerUrls = environment.partnerCheckoutUrl.length ? environment.partnerCheckoutUrl : [];
const ɵ0 = r => Array.prototype.slice.call(window.location.ancestorOrigins).indexOf(r) >= 0;
const checkWidget = (window.self !== window.top) && (window.location.ancestorOrigins && partnerUrls.some(ɵ0));
if (environment.production) {
    enableProdMode();
    if (window) {
        window.console.log = function () { };
    }
    jsPath = `/assets/scripts/prod${checkWidget ? '-widget' : ''}.js`;
}
else {
    jsPath = `/assets/scripts/staging${checkWidget ? '-widget' : ''}.js`;
    jsShieldPath = jsShieldPath + '&TEST=1';
}
(function (s, path) {
    const m = s.getElementsByTagName('script')[0];
    const a = s.createElement('script');
    a.src = path;
    a.defer = true;
    m.parentNode.insertBefore(a, m);
})(document, jsPath);
(function (s, path) {
    const m = s.getElementsByTagName('script')[0];
    const a = s.createElement('script');
    a.src = path;
    a.type = 'text/javascript';
    a.async = true;
    a.charset = 'UTF-8';
    a.onerror = (error) => {
        const data = {
            'message': 'SHIELD script load failed',
            'type': 'INFO',
            'category': 'payment-app-fe',
            'currentUrl': '/',
            'platform': 'Web',
            'applicationId': 'NA',
            'customerId': 'NA',
            'additionalInfo': {
                'merchantId': 'NA',
                'merchantName': 'NA',
                'path': '/',
                'errorMessage': 'NA',
                'error': error
            }
        };
        const domain = (environment.type === 'Local') ? 'staging-app' : ((environment.type === 'Production') ? 'app' : (environment.type).toLowerCase() + '-app');
        fetch(`https://${domain}.zestmoney.in/zestlifeweb/v1/log`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    m.parentNode.insertBefore(a, m);
})(document, jsShieldPath);
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory);
defineCustomElements(window);
export { ɵ0 };
